let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("fru0c")).then(() => parcelRequire('eFD7t'));